<template> 
  <div class="bottom-background" v-bind:style="this.bottomBackgroundStyle" v-if="!this.isApp() || this.supportFeatures.supportTigerYear">
    <div class="outer-container" v-bind:style="this.ourterContainerStyle">
      <img id="background">
      <div id="toolbar">
        <div class="back-btn" @click="goback()" v-if="this.isApp()"><img src="../../assets/images/backGrey.png"></div>
        <a v-bind:style="linkStyle" @click="openLink()">{{this.activity.link_description}}</a>
      </div>
      <div class="containter" v-if="this.activity.state !== null">
        <div class="content-area">
          <template v-if="this.activity.following_url !== null && this.activity.following_url !== undefined">
            <div class='video-container'>              
              <iframe width="560" height="315" src="https://www.youtube.com/embed/Jbzt0oZwhEU?controls=0&autoplay=1&loop=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
              <div class='banner-mask' v-if="this.activity.state !== '2'">
                  <span style="color:rgba(255,255,255,0.8); font-size: 20px;">{{this.getStateString()}}</span>
                  <span style="color:rgba(255,255,255,0.6); font-size:14px; font-family: PingFangTC-Regular; margin-top: 8px;" v-if="this.activity.state === '3'">{{this.getFullTime()}}</span>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="banner">
              <img :src='this.activity.banner_image_url' style="width: 100%; height: 100%;">
              <div class='banner-mask' v-if="this.activity.state !== '2'">
                  <span style="color:rgba(255,255,255,0.8); font-size: 20px;">{{this.getStateString()}}</span>
                  <span style="color:rgba(255,255,255,0.6); font-size:14px; font-family: PingFangTC-Regular; margin-top: 8px;" v-if="this.activity.state === '3'">{{this.getFullTime()}}</span>
              </div>
            </div>
          </template>  
          
          <span id="title" v-bind:style="memberTitleStyle" v-html="this.activity.name"></span>
          <div id="new-mebmer-block" class="member-block" v-if='this.activity.is_different_by_member && this.activity.is_show_new_member_remain_count'>
            <img class="member-image" :src='this.activity.new_member_count_image_url'> 
            <span class="member-title" v-bind:style="memberTitleStyle">{{getMemberDate(this.activity.start_date)}}後註冊</span>&nbsp;&nbsp;&nbsp;
              <span style="color: rgba(64,64,64,0.6)">剩餘</span>&nbsp;<span class="member-title" v-bind:style="memberTitleStyle">{{this.activity.new_member_remain_count}}</span>&nbsp;
              <span style="color: rgba(64,64,64,0.6)">個</span>
          </div>
          <div id="old-mebmer-block" class="member-block" v-if='this.activity.is_different_by_member && this.activity.is_show_old_member_remain_count'>
            <img class="member-image" :src='this.activity.old_member_count_image_url'> 
            <span class="member-title" v-bind:style="memberTitleStyle">{{getMemberDate(this.activity.start_date)}}前註冊</span>&nbsp;&nbsp;&nbsp;
            <span style="color: rgba(64,64,64,0.6)">剩餘</span>&nbsp;<span class="member-title" v-bind:style="memberTitleStyle">{{this.activity.old_member_remain_count}}</span>&nbsp;
            <span style="color: rgba(64,64,64,0.6)">個</span>
          </div>
          <div id="old-mebmer-block" class="member-block" v-if='!this.activity.is_different_by_member'>
            <img class="member-image" :src='this.activity.old_member_count_image_url'> 
            <span class="member-title" v-bind:style="memberTitleStyle">{{getMemberDate(this.activity.end_date)}}前註冊</span>&nbsp;&nbsp;&nbsp;
            <span style="color: rgba(64,64,64,0.6)">剩餘</span>&nbsp;<span class="member-title" v-bind:style="memberTitleStyle">{{this.activity.remain_count}}</span>&nbsp;
            <span style="color: rgba(64,64,64,0.6)">個</span>
          </div>
          <div style="text-align: center">
            <span style="color: rgba(64,64,64,1); font-size: 14px;">請輸入車牌號碼</span>
            <span style="color: rgba(64,64,64,0.6); font-size: 12px;">&nbsp;(範例：ABC-1234 或 1234-ABC)</span>
          </div>
          <div style="display: flex; margin-top: 8px;">
            <input id="plate-1" ref="plate1" v-model.trim="plate1" :disabled="activity.state!=='2' || loading" @keyup="changePlate1" class="plate-input" pattern="[a-zA-Z0-9]+" maxlength="4">
            <div style="width: 10%; justify-content: center; align-items: center; display: flex;"><div style="height: 1px; width: 18px; background-color: rgb(64, 64, 64); margin: auto;" /></div>
            <input id="plate-2" ref="plate2" v-model.trim="plate2" :disabled="activity.state!=='2' || loading" @keyup="changePlate2" class="plate-input" pattern="[a-zA-Z0-9]+" maxlength="4">
          </div>
          <div class="description-block" v-bind:style="descriptionStyle" v-html="this.activity.description"></div>
          <p style="lineHeight: 22px; font-size: 16px; padding-left:8px;" v-bind:style="memberTitleStyle">注意事項</p>
          <div class="notice-block" v-bind:style="noticeStyle" v-html="this.activity.notice" v-if="this.activity.notice !== ''"> 
            
          </div>
        </div>
        <div class="footer" id="footer" v-bind:style="footerStyle" >
          <div class="agree-label" v-bind:style="footerAgreeLabelStyle">
            <input type="checkbox" id="isAddFavoriteChecked" v-model="isAgreed" :disabled="activity.state!=='2' || loading" @click.stop="isAgreed = !isAgreed" />
            <label for="isAddFavoriteChecked">
              我已詳閱並同意悠遊卡股份有限公司蒐集處理及利用<span class="underline" @click="openExternalLink('https://www.easycard.com.tw/_upload/files/20221030.pdf')">個人資料</span>
              告知事項，並同意將我的姓名、手機號碼及車牌號碼傳送至<span class="underline" @click="openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fwww.24tms.com.tw%2F&verify=1932566d47a8df077a5d40518c60e3ac075008a722eb3c40d777383f18e6d2e0')">全鋒事業</span>
            </label>
          </div>
          <button class="button" v-bind:style="footerButtonStyle" :disabled="!buttonEnabled()" @click="click()">立即登錄</button>
        </div>
      </div>
      
      <div class="modal"  v-if="couponDialog.show">
        <div class="dialog">
          <div>
            <img src="../../assets/images/paymentSuccessful.png" style="width: 100%;">
            <div class="title" v-html="this.activity.name"></div>
            <div class="content">車牌{{ plateNumber1 + '-' + plateNumber2 }}<br>已完成登錄</div>
            <div class="dialog-btn" @click="closeCouponDialog()">我知道了</div>
            <div class="dialog-normal-btn" @click="openLink()">查看活動詳情</div>
          </div>
          
        </div>
      </div>

      <div class="modal" v-if="this.rewardDialog.show">
        <div class="dialog">
          <img src="../../assets/images/imgWinning.png" style="width: 100%;">
          <div class="title" style="font-size: 16px;">恭喜！您已獲得</div>
          <div class="content" style="color: #404040;" >{{ rewardDialog.reward_name }}</div>
          <div class="amount" style="margin: 0 auto;">NT$ {{ rewardDialog.amount }}</div>
          <div class="dialog-btn" @click="closeRewardDialog()">我知道了</div>
        </div>      
      </div>

       <div class="modal" v-if="this.errorDialog.show">
        <div class="dialog">
          <img :src="this.activity.banner_image_url" style="width: 100%; margin-bottom: 24px;" v-if="this.activity.banner_image_url !== null">
          <div class="title" v-html="this.activity.name" v-if="this.activity.name !== ''"></div>
          <div class="content" style="color: #007ac8;" >{{ errorDialog.message }}</div>
          <div class="dialog-btn" @click="closeErrorDialog()">我知道了</div>
          <div class="dialog-normal-btn" @click="openLink()"  v-if="this.activity.link !== null">查看活動詳情</div>
        </div>      
      </div>
    </div>
  </div>
</template>
<script>
import { datetimeFormat, datetimeFormat1 } from '../../utils/format';
import { mapActions, mapGetters } from 'vuex';
import { getNewYearEvent2022Config, getTmsEventLink, registerTmsEvent } from '../../api/api';
import { gotoUrl } from '../../utils/utils';
export default {
  name: 'tms',
  data() {
    return {  
      isLogin: false,
      loading: false,
      plateNumber1: '',
      plateNumber2: '',
      isAgreed: false,
      rewardDialog: {
        show: false,
        amount: 0,
        reward_name: null,
        transactionNumber: null,
      },
      couponDialog: {
        show: false,
        couponId: null,
        couponName: null,
      },
      activity: {
        name: '',
        activity_id: null,
        start_date: null,
        end_date: null,
        state: null,
        name_text_color: '#000000',
        description: '',
        description_text_color: '#000000',
        notice: '',
        notice_text_color: '#000000',
        link: null,
        link_description: '',
        link_description_text_color: '#000000',
        banner_image_url: null,
        background_image_url: null,
        footer_image_url: null,
        is_different_by_member: true,
        is_show_new_member_remain_count: true,
        is_show_old_member_remain_count: true,
        new_member_count_image_url: null,
        old_member_count_image_url: null,
        remain_count: null,
        new_member_remain_count: null,
        old_member_remain_count: null,
        full_datetime: null,
        new_member_full_datetime: null,
        under_cover_image_url: '',
        following_url: null,
      },
      footerStyle: {
        backgroundImage: null,
        bottom: 0,
        backgroundColor: '#ffffff',
      },
      footerButtonStyle: {
        backgroundImage: null,        
      },
      ourterContainerStyle: {
        backgroundImage: null,
      },
      bottomBackgroundStyle: {
        backgroundImage: null,
        height: 100 + 'vh',
      },
      footerAgreeLabelStyle: {
        opacity: '100%',
      },
      memberTitleStyle: {
        color: '#000000',
      },
      descriptionStyle: {
        color: '#000000',
      },
      noticeStyle: {
        color: '#000000',
      },
      linkStyle: {
        color: '#ffffff',
      },
      errorDialog: {
        message: '',
        show: false,
      }
    };
  },
  mounted() {
    if (this.isApp()) {      
      this.sentApp({
        action: 'immerse',
        payload: {},
      });
    }

    if (this.$route.query.activity_id != undefined) {
      this.activity.activity_id = this.$route.query.activity_id;
      this.queryConfig(this.activity.activity_id);
    }

    if (this.$route.query.plate_number1 != undefined) {
      this.plate1 = this.$route.query.plate_number1;
    }
    if (this.$route.query.plate_number2 != undefined) {
      this.plate2 = this.$route.query.plate_number2;
    }
  },

  metaInfo() {
    return { 
      title: "悠遊付-行銷活動",      
      meta: [
        { name: 'og:title', content: '悠遊付-行銷活動' }
      ],
    }
  },
  computed: {
     ...mapGetters(['sessionKey', 'sessionToken', 'supportFeatures']),
     plate1: {
      get: function () {
        return this.plateNumber1;
      },
      set: function (val) {
        this.plateNumber1 = val.toUpperCase().replace(/\W/g, '');
      },
    },
    plate2: {
      get: function () {
        return this.plateNumber2;
      },
      set: function (val) {
        this.plateNumber2 = val.toUpperCase().replace(/\W/g, '');
      },
    },
  },
  methods: {
    ...mapActions(['sentApp']),
    buttonEnabled() {
      if (this.activity.state!=='2' || this.loading) {
        return false;
      }
      if (this.plateNumber1.length >= 2 && this.plateNumber2.length >= 2 && this.isAgreed) {
        return true;
      }
      return false;
    },
    changePlate1(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (this.plate1.length >= 4) {
        this.$refs.plate1.focus();
      }
    },
    changePlate2(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (this.plate1.length >= 4) {
        this.$refs.plate1.blur();
      }
    },
    getMemberDate(date) {
        return datetimeFormat(date);
    },
    closeRewardDialog() {
      this.rewardDialog.show = false;
      this.goback();
    },
    closeCouponDialog() {
      this.couponDialog.show = false;
      this.goback();
    },
    closeErrorDialog() {
      this.errorDialog.show = false;
      this.goback();
    },
    goback() {
      if (this.isApp()) {
        this.sentApp({
          action: 'finish',
          payload: {},
        });
      }
    },
    isApp() {
      return navigator.userAgent.toUpperCase().indexOf('EASYWALLET')!==-1;
    },
    click() {
      
      if (this.isApp()) {
        if (!this.supportFeatures.supportTigerYear) {
          alert('請更新您的 APP 以參與此活動');
          return;
        }
        this.checkLoginStatus();
        if (!this.isLogin) {
          this.sentApp({
            action: 'sessionIsNull',
            payload: {
              member_upgrade_view_type: 'popup',
              member_upgrade_popup_text: '完成驗證即可參與活動，並開通「悠遊付錢包」',
            },
          });
        } else {
          this.loading = true;
          registerTmsEvent(this.activity.activity_id, this.plateNumber1 + "-" + this.plateNumber2).then((res) => {
            if (res.error !== undefined) {
              this.errorDialog.message = res.error.message;
              this.errorDialog.show = true;
            } else {
              if (res.winning_type === 'C') {                
                  this.couponDialog.couponId = res.winning_serial_number;
                  this.couponDialog.couponName = res.winning_name;
                  this.couponDialog.show = true;
              } else if (res.winning_type === 'R') {
                if (this.activity.following_url !== null && this.activity.following_url !== undefined) {
                  gotoUrl(this.activity.following_url);
                } else {
                  this.rewardDialog.transactionNumber = res.winning_serial_number;
                  this.rewardDialog.reward_name = res.winning_name;
                  this.rewardDialog.amount = res.winning_amount;
                  this.rewardDialog.show = true;
                }
              }
              this.loading = false;
              this.queryConfig(this.activity.activity_id);
            }
          });
        }
      } else {
        getTmsEventLink(this.activity.activity_id, this.plateNumber1, this.plateNumber2).then((res) => {
          gotoUrl(res.link);
        });
      }
    },
    checkLoginStatus() {
      if (this.sessionKey === null && this.sessionToken === null) {
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    getStateString() {
      switch(this.activity.state) {
        case '1':
          return '尚未開始';
        case '3':
          return '已額滿';
        case '4':
          return '已結束';
        case '2':
          return '立即領取';
      }
    },
    openExternalLink(url) {
      if (this.isApp()) {        
        this.sentApp({
          action: 'openExternalBrowser',
          payload: { url: url },
        });
      } else {
        gotoUrl(url);
      }
    },
    queryConfig(activityId) {
      getNewYearEvent2022Config(activityId).then((res) => {
        if (res !== undefined) {
          if (res.error === undefined) {
            this.activity = res;
            this.memberTitleStyle.color = this.activity.name_text_color;
            this.descriptionStyle.color = this.activity.description_text_color;
            this.noticeStyle.color = this.activity.notice_text_color;
            this.linkStyle.color = this.activity.link_description_text_color;
            this.ourterContainerStyle.backgroundImage = `url('${this.activity.background_image_url}')`;
            //this.footerStyle.backgroundImage = `url('${this.activity.footer_image_url}')`;
            this.footerButtonStyle.backgroundImage = `url('${this.activity.footer_image_url}')`;
            this.bottomBackgroundStyle.backgroundImage = `url('${this.activity.under_cover_image_url}')`;            
            this.footerAgreeLabelStyle.opacity = (this.activity.state!=='2' || this.loading) ? '40%' : '100%';
          } else {
            this.errorDialog.message = res.error.message;
            this.errorDialog.show = true;
          }
        }
      });
    },
    getFullTime() {
      if (this.activity.state === '3') {
        return datetimeFormat1(this.activity.full_datetime);      
      } else {
        return '';
      }
    },
    openLink() {
      this.openExternalLink(this.activity.link, this.plateNumber1, this.plateNumber2);
    },
    gotoCoupon() {
      this.sentApp({
        action: 'goCouponDetail',
        payload: { couponId: this.couponDialog.couponId },
      });
    },
    gotoTransactionDetail() {
      this.sentApp({
        action: 'goTransactionDetail',
        payload: { transactionNumber: this.rewardDialog.transactionNumber },
      });
    },
    openEasycardWeb() {
      this.openExternalLink('https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Flihi1.com%2FO3uZ1&verify=208c58125eeeef769baff899de5783966b61c2098b78885e82a935e6533a9551');
    },
  },
};
</script>
<style lang="scss" scoped>
.back-btn {
  width: 44px;
  height: 44px;
  position: fixed;
  left: 8px;
}

.back-btn img {
  width: 100%;
}

#app {
  overflow: hidden;
  background: #ff0000;
  height: calc(var(--vh, 1vh) * 100);
}

.amount {
  color: #00a12d;
  font-size: 21px;
}

.member-block span {
  display: table-cell;
  vertical-align:middle;
  font-size: 14px;
  font-family: PingFangTC-Regular;
  color: v-bind('activity.name_text_color');
}

.member-block {
  display: table;
  background-color: rgba(64,64,64,0.05);
  padding: 8px 12px;
  margin-bottom: 8px;
  width: -webkit-calc(100% - 22px);
  width:    -moz-calc(100% - 22px);
  width:         calc(100% - 22px);
}

.member-block img {
  margin-right: 8px;
}

.description-block {
  margin: 12px 8px;
  font-size: 14px;
  font-family: PingFangTC-Regular;
}

.notice-block {
  margin: 12px 8px;
  font-size: 14px;
  font-family: PingFangTC-Regular;
}

.member-title {
  
}

#toolbar {
  margin-top: 30px;
  position: relative;
  z-index: 2;
  width: 100%;
  height: 44px;
  background-color: transparent;
  vertical-align: middle;
  max-width: 420px;
}

span.underline {
  text-decoration-line: underline;
  text-decoration-color: rgb(64, 64, 64);
}

#toolbar a {
  position: absolute;
  right: 0px;
  height: 100%;
  margin-right: 16px;
  font-size: 17px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.member-image {
  max-width: 42px;
}

#title {
  z-index: 2;
  margin-top: 12px;
  margin-bottom: 12px;
  text-align: center;
  display:block;
  font-size: 20px;
  color: v-bind('activity.name_text_color');
}

.content-area {
  z-index: 2;
  margin-left: 27px;
  margin-right: 27px;
  padding: 11px;
  height: 100vh;
  overflow-y: auto;
  margin-top: 12%;
  max-height: -webkit-calc(100vh - 310px);
  max-height:    -moz-calc(100vh - 310px);
  max-height:         calc(100vh - 310px);
  -webkit-overflow-scrolling: touch;  
  //scroll-snap-align: center;
}

::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}

.banner {
  z-index: 2;
  max-width: 420px;
  border-radius: 10px;
  position: relative;
  margin: 11px;
}

.banner img {
  border-radius: 10px;
}


.video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;
}
.video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.footer {
  z-index: 2;
  width: 100%;
  min-height: 148px;
  padding-bottom: 5%;
  position: fixed;
  bottom: 0;
  justify-content: center;  
  align-items: center;  
  max-width: 420px;
  margin: 0 auto;
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
}

.footer button:disabled{
  opacity: 0.3;    
}

.footer button {
  width: 90%; 
  height: 44px; 
  color: #ffffff;
  font-size: 20px;
  background: no-repeat scroll 0 0 transparent;
  background-position: center; 
  background-size: contain;
  border: none;
  text-align: center;
  margin: 0 24px;
}



.footer-image {
  height: 100%;
  width: 100%;
  max-width: 420px;
  z-index: 0;  
}

.containter {  
  z-index: 2;
  padding-left: 0px;
  overflow: hidden;
  max-width: 420px;
  //overflow-y: scroll;
  //scroll-snap-type: y mandatory;
}

.outer-container {
  width: auto;
  max-width: 420px;
  align-content: center;
  margin: 0 auto;
  background-origin: border-box;
  background-repeat: no-repeat;
  background-size: cover;
}

#background {
  width: 100%;
  height: 100%;
  z-index: 0;
  top: 0;
  max-width: 420px;
}

.dialog {
  position: fixed;
  transform: calc(100vh - 50%);
  margin: 0 auto;  
  padding: 24px 20px;
  background: white;
  width:311px;
  min-height: 126px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
}

.dialog .title {
  margin: 0 auto; 
  text-align: center;
  font-size: 20px;
}

.banner-mask {
  width: 100%;
  max-width: 420px;
  //background: rgba(0,0,0,0.8);
  position: absolute;
  background-image: url('../../assets/images/TMS/bannerMask.png');
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  top: 0;
  height: 100%;
  display: flex;
  justify-content: center;
  vertical-align: middle;
  flex-direction: column;
  text-align: center;
}



.dialog .content {
  margin: 8px auto; 
  text-align: center;
  font-size: 24px;
  color: rgb(0, 122, 200);
}

.dialog .dialog-btn {
   margin: 24px auto 0px auto;
}

.dialog .dialog-normal-btn {
  margin: 24px auto 0px auto; 
  text-align: center;
}

.modal {
  width: 100%;
  height: 100%;
  background: #00000066;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  
}


.dialog-btn {
  background: #007ac8;
  border-radius: 22px;
  color: white;
  font-size: 16px;
  text-align: center;
  padding: 12px 8px;
  min-width: 271px;
}

.bottom-background {
  background-position: top center;
  position: relative;
  background-size: cover;
}

.agree-label {
  font-size: 14px;
  margin: 12pt 24pt 12pt 24pt;
  position: relative;
  display: block;

  input + label {
    display: block;
    text-align: left;
  }

  label {
    text-align: left;
    display: inline-block;
    margin-left: 45px;
    vertical-align: center;
    align-items: center;
  }

  a:active {
    -webkit-tap-highlight-color: transparent;
  }
}

.agree-label label::before {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.plate-input {
  background-color: rgba(64, 64, 64, 0.05); 
  height: 44px; 
  border: 0; 
  width: 45%; 
  text-align: center; 
  text-transform:uppercase;
}

</style>
